import { IconPlaneLand16 } from '@warp-ds/icons/react/plane-land-16';
import { IconPlaneTakeOff16 } from '@warp-ds/icons/react/plane-take-off-16';

import { formatISODateTime, formatReadableDateShort, formatReadableTime } from 'shared/util/datetime-fns';
import type { Offer } from '@/interfaces';

export const FlightDateAndTime = ({ departureDate, returnDate }: Pick<Offer, 'departureDate' | 'returnDate'>) => {
    const departure = new Date(departureDate);
    const ret = new Date(returnDate);

    return (
        <p className="flex flex-row items-center gap-4 text-detail">
            <IconPlaneTakeOff16 aria-hidden />
            <time className="flex flex-row gap-4 capitalize" dateTime={formatISODateTime(departure)}>
                <span className="font-bold">{formatReadableDateShort(departure)}</span>
                <span>kl. {formatReadableTime(departure)}</span>
            </time>
            <span>-</span>
            <IconPlaneLand16 aria-hidden />
            <time className="flex flex-row gap-4 capitalize" dateTime={formatISODateTime(ret)}>
                <span className="font-bold">{formatReadableDateShort(ret)}</span>
                <span>kl. {formatReadableTime(ret)}</span>
            </time>
        </p>
    );
};
